module.exports = __webpack_public_path__ + "assets/61e2019a6d5f19be1782019b546f5fbd.png";